import React, {useState, useEffect} from 'react'

import {
    useHistory
} from 'react-router-dom'

import { 
    Auth,
} from 'aws-amplify'

import { 
    ComponentsDiv
} from '../Styles/Pages/LogInStyles'

import { 
    Alert,
    Info,
    TopBackgroundDiv,
    BottomBackgroundDiv
} from '../Styles/BaseStyles'

import LogInFields from '../Components/Action/LogInFields'

import { useSelector, useDispatch } from 'react-redux'

import { reset as logInReset} from '../Redux/Slices/LogInSlice'
import { reset as forgotPasswordReset } from '../Redux/Slices/ForgotPasswordSlice'
import { reset as userReset } from '../Redux/Slices/UserSlice'

function LogIn(props){
    let history = useHistory()

    const dispatch = useDispatch()

    const [load,setLoad] = useState(false)

    const storage = useSelector(state => state.user.storage)

    const error = useSelector(state => state.logIn.error)
    const errorPhrase = useSelector(state => state.logIn.errorPhrase)
    const info = useSelector(state => state.logIn.info)
    const infoPhrase = useSelector(state => state.logIn.infoPhrase)

    dispatch(forgotPasswordReset())

    useEffect(() => {
        switch(storage){
            case 'localstorage':
                Auth.configure({storage: localStorage})
                break
            case 'sessionstorage':
                Auth.configure({storage: sessionStorage})
                break
            default:
                break
        }
        Auth.currentAuthenticatedUser().then(() => {
            history.push('/hub')
        })
        .catch(() => {
            dispatch(userReset())
            setLoad(true)
        })
    }, [])

    useEffect(() => {
        if(error || info){
            const timeId = setTimeout(() => {
                dispatch(logInReset())
            }, 5000)
            return () => {
                clearTimeout(timeId)
            }
        }
    }, [dispatch,error,info])

    var viewer = (
        <>
        </>
    )

    if(load){
        viewer = (
            <>
                <TopBackgroundDiv />
                <BottomBackgroundDiv />
                {error && <Alert style={{top: "0.5rem", position: "absolute"}}>{errorPhrase}</Alert>}
                {info && <Info style={{top: "0.5rem", position: "absolute"}}>{infoPhrase}</Info>}
                <ComponentsDiv>
                    <LogInFields />
                </ComponentsDiv>
            </>
        )
    }

    return (
        <>
            {viewer}
        </>
    )
}

export default LogIn